import React from "react";
import CertificadoCard from "./Certificado/CertificadoCard";
import NovoCertificadoCards from "./Certificado/NovoCertificadoCards";
import DuvidasFrequentes from "./Certificado/DuvidasFrequentes";
import EditarCertificadoModal from "./Certificado/EditarCertificadoModal";
import CommonSwal from "../../components/Swal/commonSwal";
import ErrorSwal from "../../components/Swal/errorSwal";
import Validation from "../../helpers/Validation";
import { AppContext } from "../../contexts/AppContext";
import CertificadoApiClient from "../../api/certificado";
import useApi from "../../hooks/useApi";
import ComprarCertificadoModal from "./Certificado/ComprarCertificadoModal";
import OptionsSwal from "../../components/Swal/optionsSwal";

function Certificado() {
  const [values, setValues] = React.useState({});
  const [validade, setValidade] = React.useState("");
  const [validadeModal, setValidadeModal] = React.useState(false);
  const [comprarCertificadoModal, setComprarCertificadoModal] =
    React.useState(false);
  const { session } = React.useContext(AppContext);

  const { request: getCerificado, data: cerificadoResponse } = useApi(
    CertificadoApiClient.getCertificado
  );
  const postCertificadoApi = useApi(CertificadoApiClient.postCertificado);
  const renovaCertificadoApi = useApi(CertificadoApiClient.renovaCertificado);

  //Busca dados do certificado ao renderizar tela
  React.useEffect(() => {
    if (session.empresa) getCerificado(session.empresa.replace(/E/gi, ""));
  }, [getCerificado, session.empresa]);

  //Define o retorno da API nos valores dos campos
  React.useEffect(() => {
    if (!cerificadoResponse) return;
    setValidade(cerificadoResponse.data_vencimento);
  }, [cerificadoResponse]);

  const togEditarCertificadoModal = async () => {
    setValues({});
    setValidadeModal(true);
  };

  const togComprarCertificadoModal = async () => {
    setValues({ ecnpj: 0, ecpf: 0, valor_ecnpj: 180, valor_ecpf: 110 });
    setComprarCertificadoModal(true);
  };

  const salvaValidade = async () => {
    const formData = new FormData();
    formData.append("data_vencimento", values?.validade);

    if (Validation.verificarForm(formData))
      return ErrorSwal({ text: "Favor preencher validade!" });

    const response = await postCertificadoApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    CommonSwal({
      title: "Solicitação efetuada com sucesso!",
      icon: "success",
    }).then(() => {
      setValidadeModal(false);
      getCerificado(session.empresa.replace(/E/gi, ""));
    });
  };

  const compraCertificado = async () => {
    const formData = new FormData();
    formData.append("data_vencimento", values?.vencimento);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Deve ser escolhido uma data de vencimento válida para a cobrança.",
      });

    formData.append("valor_certificado_cnpj", values?.valorEcnpj || 0);
    formData.append("valor_certificado_cpf", values?.valorEcpf || 0);
    formData.append("certificado_cnpj", values?.ecnpj || 0);
    formData.append("certificado_cpf", values?.ecpf || 0);

    if (!values?.ecnpj && !values?.ecpf)
      return ErrorSwal({
        text: "O valor da cobrança deve ser diferente de zero. Selecione uma quantidade válida de certificados digitais.",
      });

    const response = await renovaCertificadoApi.request(
      session.empresa.replace(/E/gi, ""),
      formData
    );
    if (!response) return;
    OptionsSwal({
      title: "Sua compra foi realizada com sucesso!",
      text: "A geração do seu certificado será agendada após a confirmação do pagamento. Obrigado!",
      icon: "success",
      confirmButtonText: "Link da cobrança",
      denyButtonText: "Fechar",
    }).then((result) => {
      setComprarCertificadoModal(false);
      getCerificado(session.empresa.replace(/E/gi, ""));
      if (result.isConfirmed && response.dados.link) {
        window.open(response.dados.link, "_blank");
      }
    });
  };

  return (
    <>
      <CertificadoCard
        togEditarCertificadoModal={togEditarCertificadoModal}
        togComprarCertificadoModal={togComprarCertificadoModal}
        validade={validade}
      />
      <NovoCertificadoCards
        togComprarCertificadoModal={togComprarCertificadoModal}
      />
      <DuvidasFrequentes />
      <EditarCertificadoModal
        modalHook={{ validadeModal, setValidadeModal }}
        valuesHook={{ values, setValues }}
        salvaValidade={salvaValidade}
      />
      <ComprarCertificadoModal
        modalHook={{ comprarCertificadoModal, setComprarCertificadoModal }}
        valuesHook={{ values, setValues }}
        compraCertificado={compraCertificado}
      />
    </>
  );
}

export default Certificado;
